import { render, staticRenderFns } from "./BosquesTerrenos.vue?vue&type=template&id=318d83ea"
import script from "./BosquesTerrenos.vue?vue&type=script&lang=js"
export * from "./BosquesTerrenos.vue?vue&type=script&lang=js"
import style0 from "./BosquesTerrenos.vue?vue&type=style&index=0&id=318d83ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports